import { useEffect, useRef } from "react";

import { applyInitialLocale } from "~/lib/locale-bootstrap";

export function LocaleBootstrap() {
  const hasBootstrappedRef = useRef(false);

  useEffect(() => {
    if (hasBootstrappedRef.current) {
      return;
    }

    hasBootstrappedRef.current = true;
    applyInitialLocale();
  }, []);

  return null;
}
